import { render, staticRenderFns } from "./WorkerDetail.vue?vue&type=template&id=1e97e39d&scoped=true"
import script from "./WorkerDetail.vue?vue&type=script&lang=ts"
export * from "./WorkerDetail.vue?vue&type=script&lang=ts"
import style0 from "./WorkerDetail.vue?vue&type=style&index=0&id=1e97e39d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e97e39d",
  null
  
)

export default component.exports